import { render, staticRenderFns } from "./PaymentPlan.vue?vue&type=template&id=5b8f8e6a"
import script from "./PaymentPlan.vue?vue&type=script&lang=js"
export * from "./PaymentPlan.vue?vue&type=script&lang=js"
import style0 from "./PaymentPlan.vue?vue&type=style&index=0&id=5b8f8e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VDialog,VSimpleTable})
